// ══════════════════════════════════════════════════════════════════════════════�?// Home Stock �?radio list with photo thumbnails (manual add / per-item photo)
// ══════════════════════════════════════════════════════════════════════════════�?
import { StocktakeUploadedPhotoThumb } from './StocktakeUploadedPhotoThumb';

export type StocktakePhotoPickerItem = {
  id: string;
  displayUrl: string;
  authedApiPath?: string;
};

type InventoryStocktakePhotoRadioPickerProps = {
  photos: StocktakePhotoPickerItem[];
  selectedPhotoId: string;
  onSelectPhotoId: (photoId: string) => void;
  groupName: string;
  t: (key: string, params?: Record<string, string | number>) => string;
  label?: string;
  disabled?: boolean;
};

export const InventoryStocktakePhotoRadioPicker = ({
  photos,
  selectedPhotoId,
  onSelectPhotoId,
  groupName,
  t,
  label,
  disabled = false,
}: InventoryStocktakePhotoRadioPickerProps) => {
  if (photos.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {label ? (
        <span className="text-xs font-medium text-gray-700 dark:text-gray-200">{label}</span>
      ) : null}
      <ul
        className="flex flex-col gap-2"
        role="radiogroup"
        aria-label={label ?? t('inventory.itemPhotoPickerAria')}
      >
        {photos.map((photo, index) => {
          const checked = selectedPhotoId === photo.id;
          return (
            <li key={photo.id}>
              <label
                className={
                  checked
                    ? 'flex cursor-pointer items-center gap-3 rounded-xl border-2 border-primary-600 bg-emerald-50/50 p-2 dark:border-emerald-600 dark:bg-emerald-950/30'
                    : 'flex cursor-pointer items-center gap-3 rounded-xl border border-gray-200 bg-white p-2 dark:border-gray-600 dark:bg-gray-900'
                }
              >
                <input
                  type="radio"
                  name={groupName}
                  value={photo.id}
                  checked={checked}
                  onChange={() => onSelectPhotoId(photo.id)}
                  disabled={disabled}
                  className="h-4 w-4 shrink-0 border-gray-300 text-primary-600 focus:ring-primary-500"
                  aria-label={t('inventory.wizard.aiSelectPhotoCheckboxAria', { n: index + 1 })}
                />
                <StocktakeUploadedPhotoThumb
                  displayUrl={photo.displayUrl}
                  authedApiPath={photo.authedApiPath}
                  imageAlt={t('inventory.uploadedStocktakePhotoAlt', { n: index + 1 })}
                  enlargeAriaLabel={t('inventory.enlargePhotoAria')}
                  closeViewerLabel={t('common.closeViewer')}
                  removeAriaLabel=""
                  onRequestRemove={() => undefined}
                  actionsDisabled
                />
                <span className="text-sm font-medium text-gray-800 dark:text-gray-100">
                  {t('inventory.uploadedStocktakePhotoAlt', { n: index + 1 })}
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
